<template>
  <div id="shangx">

      <div class="fflex ffbet">
          <ul class="fflex headBox">
              <li @click="jump('shanglei')">商品类型</li>
              <li @click="jump('gongys')">供应商</li>
              <li @click="jump('shangx')">商品信息</li>
              <li @click="jump('wuliu')">物流设置</li>
              <li @click="jump('churukl')" >出入库类型</li>
              <li class="active">日志列表</li>
          </ul>
          <div class="sousuok">
              <!--<el-input-->
                      <!--size="mini"-->
                      <!--placeholder="供应商查询"-->
                      <!--v-model="gyshang"-->
              <!--&gt;-->

                  <!--<i  class="el-icon-search el-input__icon"-->
                      <!--slot="suffix"-->
                      <!--v-on:click="searchname">-->
                  <!--</i>-->
              <!--</el-input>-->
          </div>
      </div>

      <div class="fflex ffend" style="margin: 10px 0;line-height: 32px;color: #999">

          <div>


              <el-date-picker
                      style="width: 260px;margin-right: 10px"
                      v-model="setime"
                      type="daterange"
                      :name="['time_s','time_e']"
                      range-separator="-"
                      size="small"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
              </el-date-picker>


              <input type="text" class="xiala" placeholder="日志内容查询" v-model="search"  @keyup.enter="chaxun" style="width: 120px;margin-right: 10px;margin-left: 5px" >
              <el-button type="warning"  size="mini" @click="chaxun" >查询</el-button>
          </div>



      </div>

      <div class="tableBox">
          <table class="table table-bordered" >
              <thead>
              <tr>
                  <th>序号</th>
                  <th>日期</th>
                  <th>管理员</th>
                  <th>登陆IP</th>
                  <th>日志内容</th>


              </tr>
              </thead>
              <tbody>
              <tr  v-for="(ta,taindex) in tabledata" :key="taindex">
                  <td>{{taindex+1}}</td>
                  <td >
                      {{ta.create_time}}
                  </td>
                  <td >{{ta.user_name}}</td>
                  <td >{{ta.ip}}</td>
                  <td >{{ta.content}}</td>

              </tr>

              </tbody>
          </table>
          <p>共有{{total}}条记录  当前{{currentpage}}页/共{{pagetotal}}页</p>
      </div>

      <div class="table-bottom">
          <div>
              <el-pagination
                      @current-change="handleCurrentChange"
                      :current-page="currentpage"
                      :page-size="pageone"
                      background
                      layout="prev, pager, next"
                      :total="total">
              </el-pagination>
          </div>
      </div>






  </div>
</template>

<script>

export default {
    data() {
        return {
            token:'',
            gyshang:'',
            currentpage:1,
            pageone:10,
            total:100,
            shangxt:false,
            zhuang:'',
            Ttitle:'',
            dis:false,
            setime:'',
//            shangphone:''
            goodsleiop:[
                {
                    value: '',
                    label: '请选择'
                }, {
                    value: '195',
                    label: '非消耗品'
                }, {
                    value: '196',
                    label: '日常消耗品'
                }, {
                    value: '197',
                    label: '固定资产'
                }
            ],
            goodslei:'',
            ylimg:'https://saas.gymbaby.cn/static/qmsj/img/jinxiaocun/default2.jpg',
            imgbox:[],
            pagetotal:1,
            search:'',
            time_s:'',
            time_e:"",
            tabledata:''


        };
    },
    methods:{
        chaxun:function () {
          let self=this;
          self.gonggong()
        },
        gonggong:function () {
            let self=this;
            let time_s=$('input[name="time_s"]').val()
            let time_e=$('input[name="time_e"]').val()
            self.time_s=time_s;
            self.time_e=time_e;
            $.ajax({
                type: 'POST',
                url:process.env.apiUrl + 'saas/JxcSupplier/findLog',
                dataType:'json',
                data:{
                    page: self.currentpage,
                    pageone: self.pageone,
                    token:self.token,
                    time_s:self.time_s,
                    time_e:self.time_e,
                    search:self.search
                },
                success:function (data) {
                    if(data.status==1){
                        self.tabledata=data.data;
                        self.total=Number(data.map.count)
                        self.pagetotal=Number(data.map.pagetotal)
                    }else{
                        self.tabledata='';
                        self.total=0;
                        self.pagetotal=1
                    }

                }
            })

        },


        handleCurrentChange:function (i) {
            let self=this;
            self.currentpage=i
            self.gonggong()
        },
        jump:function (e) {
            this.$router.push({
                'name':e
            })
        },



    },
    mounted:function(){
        var self=this;
        self.token=$.cookie('token');

        $.ajax({
            type: 'POST',
            url:process.env.apiUrl + 'saas/JxcSupplier/findLog',
            dataType:'json',
            data:{
                page: self.currentpage,
                pageone: self.pageone,
                token:self.token,

            },
            success:function (data) {
                if(data.status==1){
                    self.tabledata=data.data;
                    self.total=Number(data.map.count)
                    self.pagetotal=Number(data.map.pagetotal)
                }else{
                    self.tabledata='';
                    self.total=0;
                    self.pagetotal=1
                }

            }
        })



    }


}
</script>

<style scoped>
    .xiala{
        width: 200px;
        height: 32px;
        line-height: 32px;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: 13px;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);

    }
    .yulantu{
        width: 100px;
        height: 100px;
        border-radius: 6px;
        margin-left: 10px;
    }
    ul{
        list-style: none;
    }
    #shangx p,label,ul{
        margin: 0;
        padding:0 ;
    }
    .fflex{
        display: flex;
        display:-webkit-flex;
    }
    .ffbet{
        justify-content: space-between;
    }
    .ffend{
        justify-content: flex-end;
    }
    #shangx *{
        box-sizing: border-box;
    }
    #shangx{
        box-sizing: border-box;
        padding: 10px;
    }
    .headBox li{
        width: 75px;
        background: #E6BE8A;
        height: 30px;
        line-height: 30px;
        margin-right: 8px;
        border-radius:  5px 5px 0 0;
        text-align: center;
        color: #fff;

    }
    .headBox li.active{
        background: #ecebfd;
        color:#E6BE8A ;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
    }
.purBtnsz{
    background: #E6BE8A!important;
    height: 26px;
    border: none!important;
}
.marBo2{
    margin-bottom: 10px;
}
.inputT{
    display: inline-block;
    width: 100px;

}



</style>
<style>


</style>



// WEBPACK FOOTER //
// src/pages/jinxc/rizhi.vue